import React from "react";

const Java_random = () => {
  return (
    <div>
      <h1>Java random</h1>
      <p>This page provides explanations, examples, and common use-cases for Java random in Java.</p>
    </div>
  );
};

export default Java_random;
